// extracted by mini-css-extract-plugin
export const mainSection = "advertise-module--mainSection--1n5zA";
export const contentWrap = "advertise-module--contentWrap--2g8fG";
export const content = "advertise-module--content--2Nvd0";
export const wrapper = "advertise-module--wrapper--IVq4C";
export const componentWrapper = "advertise-module--componentWrapper--38-sv";